const storagePrefix = "csp_app_";

const storage = {
  setAuth: (token: string, email: string) => {
    localStorage.setItem(`${storagePrefix}token`, token);
    localStorage.setItem(`${storagePrefix}email`, email);
  },
  getToken: () => {
    return localStorage.getItem(`${storagePrefix}token`) || "";
  },
  getEmail: () => {
    return localStorage.getItem(`${storagePrefix}email`) || "";
  },
  clearAuth: () => {
    localStorage.removeItem(`${storagePrefix}token`);
    localStorage.removeItem(`${storagePrefix}email`);
  },
};

export default storage;
